import fetch,{postFrom} from '../utils/fetch';


export function rolelist(params) {
  return fetch({
    method: 'POST',
    url: '/role/list',
    data: params
  })
}

export function roleadd(params) {
  return fetch({
    method: 'POST',
    url: '/role/add',
    data: params
  })
}

export function roleedit(params) {
  return fetch({
    method: 'POST',
    url: '/role/edit',
    data: params
  })
}


export function roleget(params) {
  return fetch({
    method: 'GET',
    url: '/role/get',
    params
  })
}

export function rolecopyRolelist(params) {
  return fetch({
    method: 'POST',
    url: '/role/copyRolelist',
    data:params
  })
}


export function roleblockUp(params) {
  return fetch({
    method: 'GET',
    url: '/role/blockUp',
    params
  })
}

export function rolecondition(params) {
  return fetch({
    method: 'POST',
    url: '/role/condition',
    data:params
  })
}
export function roledelete(params) {
  return fetch({
    method: 'GET',
    url: '/role/delete',
    params
  })
}

export function rolegetByIds(params) {
  return fetch({
    method: 'GET',
    url: '/role/getByIds',
    params
  })
}
export function rolerolelist(params) {
  return fetch({
    method: 'POST',
    url: '/role/rolelist',
    data:params
  })
}

export function copyRolePermission(params) {
  // return fetch({
  //   method: 'POST',
  //   url: '/role/copyRolePermission',
  //   data:params
  // })
  return postFrom('/role/copyRolePermission',params)
}

export function addRolePermission(params) {
  return postFrom('/role/addRolePermission',params)
}

